<template>
    <div class="accordion" :id="accordionId">
        <div
            class="accordion-item border-0"
            v-for="(item, idx) in items"
            :key="idx"
        >
            <h2 class="accordion-header" :id="`${accordionId}-heading-${idx}`">
                <button
                    :class="['accordion-button section-title pt-0', { collapsed: idx !== 0 }]"
                    type="button"
                    data-bs-toggle="collapse"
                    :data-bs-target="`#${accordionId}-collapse-${idx}`"
                    :aria-expanded="idx === 0"
                    :aria-controls="`${accordionId}-collapse-${idx}`"
                >
                    <SectionTitle :title="$t(item.title, { count: store.ratingInfo.filtered_count || 0 })" extra-class="line-title-wrapper"/>
                    <div class="accordion-arrow">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16" fill="currentColor">
                            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 1 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </div>
                </button>
            </h2>
            <div
                :id="`${accordionId}-collapse-${idx}`"
                :class="['accordion-collapse collapse', { show: idx === 0 }]"
                :data-bs-parent="`#${accordionId}`"
                :aria-labelledby="`${accordionId}-heading-${idx}`"
            >
                <div class="accordion-body bg-transparent px-0 m-0 mt-0 mt-md-0 m-md-4">
                    <div v-if="item.body" v-html="item.body"></div>
                    <component
                        v-else-if="item.component !== Ratings"
                        :is="item.component"
                        v-bind="item.props"
                    />
                    <Ratings
                        v-else
                        v-bind="item.props"
                        ref="reviewsRef"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useProductPageStore } from '~/stores/ProductPageStore'
const Specifications = defineAsyncComponent(() => import('~/components/Product/Page/Specifications.vue'))
const Ratings = defineAsyncComponent(() => import('~/components/Product/Page/Ratings/Ratings.vue'))
const SectionTitle = defineAsyncComponent(() => import('~/components/Product/SectionTitle.vue'))


const { product, accordionId } = defineProps({
    product: { type: Object, required: true },
    accordionId: { type: String, required: true }
})

const store = useProductPageStore()
const reviewsRef = ref(null)

const items = [
    { title: 'products.details', body: product.frontend_description },
    { title: 'products.specifications', component: Specifications, props: { product } },
    { title: 'products.reviews', component: Ratings, props: { product } }
]

onMounted(() => {
    const idxRatings = items.findIndex(i => i.component === Ratings)

    items.forEach((_, idx) => {
        const collapseEl = document.getElementById(`${accordionId}-collapse-${idx}`)
        const headingEl = document.getElementById(`${accordionId}-heading-${idx}`)

        if (collapseEl && headingEl) {
            collapseEl.addEventListener('shown.bs.collapse', () => {
                headingEl.scrollIntoView({ behavior: 'smooth', block: 'start' })
                if (idx === idxRatings) {
                    reviewsRef.value?.[0]?.loadRatings()
                }
            })
        }
    })
})
</script>

<style scoped>
.accordion-button.section-title::before,
.accordion-button.section-title::after {
    display: none !important;
}
.accordion-button.section-title {
    flex-direction: column;
    background: transparent;
    padding: 1rem 0;
}

.accordion-button.section-title[aria-expanded="true"] .accordion-arrow svg {
    transform: rotate(180deg);
}
.accordion-arrow svg {
    transition: transform 0.2s;
}
</style>
